import script from "./ModuleShow.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModuleShow.vue?vue&type=script&setup=true&lang=ts"

import "./ModuleShow.vue?vue&type=style&index=0&id=4ae72195&lang=scss"

const __exports__ = script;

export default __exports__